// extracted by mini-css-extract-plugin
export var closeButton = "_k1-2";
export var closeButtonIcon = "_k1-3";
export var lightboxContent = "_k1-1";
export var lightboxOverlay = "_k1-0";